import { createClient } from "@supabase/supabase-js";

let client;

/**
 * Browser Supabase client (anon key only). Returns null if env is missing.
 * @returns {import("@supabase/supabase-js").SupabaseClient|null}
 */
export function getSupabase() {
  const url = process.env.REACT_APP_SUPABASE_URL;
  const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
  if (!url || !anonKey) return null;
  if (!client) {
    client = createClient(url, anonKey, {
      auth: { persistSession: true, autoRefreshToken: true },
    });
  }
  return client;
}
